import gql from 'graphql-tag';

import { clientWeb, persistor } from '../graphqlAPI';

const USER_CHECK_EMAIL = gql`
  query userCheckEmail($email: String!) {
    userCheckEmail(email: $email) {
      valid
    }
  }
`;

const executeQuery = async (email) => {
  const result = await clientWeb.query({
    query: USER_CHECK_EMAIL,
    variables: {
      email,
      fetchDate: new Date().getTime().toString(),
    },
    fetchPolicy: 'no-cache',
  })
    .then((queryResult) => queryResult)
    .catch((queryError) => {
      const errorMessage = `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`;
      console.log('\x1b[31m%s\x1b[0m', errorMessage);

      return null;
    });

  if (result.data && result.data.userCheckEmail) {
    const { data: { userCheckEmail } } = result;
    return userCheckEmail;
  }

  return [];
};

const userCheckEmail = async (email) => {
  try {
    const JSONObject = await executeQuery(email);

    if (persistor) {
      persistor.persist();
    }

    return JSONObject;
  } catch (jsonError) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: JSON Object Error: ${jsonError}`);

    if (persistor) {
      const persistorStatus = await persistor.restore().then(() => 'OK');
      console.log(`${new Date().toLocaleTimeString()} ~ Client: Apollo Cache Restored - ${persistorStatus}`);

      try {
        const JSONObject = await executeQuery('cache');

        return JSONObject;
      } catch (jsonErrorAfterCacheRestore) {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: JSON Object Error after Cache Restore, sending 404: ${jsonErrorAfterCacheRestore}`);
        return null;
      }
    }
    return null;
  }
};

export default userCheckEmail;
